import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.timeout = 60 * 1000;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;

export default axios;
